export const locale = {
  lang: 'en',
  user_inactivity: {
    STAY_CONNECTED: 'Stay connected',
    INACTIVE_SESSION: 'Your session will be disconnected due to inactivity',
    CONNECTING: 'Connecting...',
  }
};

